import { Pill } from '@deliveryhero/pd-cookbook/components/Pill';
import { Grid } from '@mui/material';

import { ButtonListSelectProps } from './types';

export default function ButtonListSelect<T extends string>({
  buttons,
  handleClick,
  disabled
}: ButtonListSelectProps<T>) {
  const filteredButtons = disabled
    ? buttons.filter((button) => button.selected)
    : buttons;

  return (
    <Grid container direction="row" spacing={2}>
      {filteredButtons.map(({ id, label, selected }, index) => (
        <Grid item key={`button-list-${id}-${label}`}>
          <Pill
            key={index}
            id={label}
            disabled={disabled}
            checked={Boolean(selected)}
            label={label}
            onChange={() => handleClick(id)}
          />
        </Grid>
      ))}
    </Grid>
  );
}
